import { render, staticRenderFns } from "./VImportantDates.vue?vue&type=template&id=78026164&"
import script from "./VImportantDates.vue?vue&type=script&lang=js&"
export * from "./VImportantDates.vue?vue&type=script&lang=js&"
import style0 from "./VImportantDates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports